module.exports = __webpack_public_path__ + "static/media/flattube.f1295276.png";